<template>
    <div id="requests">
        <RequestsTable
            :requestParams="{
                clientId: client.id
            }"
            :showClient="true"
            :showOfficer="false"
            emptyText="This client has not placed any requests."
        />
    </div>
</template>

<script>
import RequestsTable from '../../requests/requests-table';

export default {
    props: ['client'],

    components: { RequestsTable },

    mounted() {
        this.$el.parentElement.parentElement.parentElement.style.maxWidth = 'none';
        this.$el.parentElement.parentElement.parentElement.style.width = 'auto';
    },

    beforeUnmount() {
        this.$el.parentElement.parentElement.parentElement.style.removeProperty('max-width');
        this.$el.parentElement.parentElement.parentElement.style.removeProperty('width');
    }
};
</script>

<style lang="scss" scoped></style>
